function createJSONRequest(
  method: "POST" | "PUT" | "DELETE",
  url: URL | string,
  data: any
) {
  const payload = JSON.stringify(data);

  const request = new Request(url.toString(), {
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    method,
    body: payload,
  });

  return request;
}

export function putJSON(url: URL | string, data: any) {
  return createJSONRequest("PUT", url, data);
}

export function postJSON(url: URL | string, data: any) {
  return createJSONRequest("POST", url, data);
}

export function deleteJSON(url: URL | string, data: any) {
  return createJSONRequest("DELETE", url, data);
}

export function postFile(url: URL | string, file: Blob) {
  const data = new FormData();
  data.append("file", file);

  return new Request(url.toString(), {
    method: "POST",
    body: data,
  });
}

export function getRaw(url: URL | string, accept: string = "*/*") {
  return new Request(url.toString(), {
    method: "GET",
    headers: {
      accept,
    },
  });
}

export function getJSON(url: URL | string) {
  return getRaw(url, "application/json");
}
